import React from 'react';
import { addDays, endOfDay } from 'date-fns';
import { Form, DatePicker } from '@bynder/design-system';
import { Translate } from '@bynder/localization';

interface Props {
	startDate: string;
	endDate: string;
	onStartDateChange: (value: string) => void;
	onEndDateChange: (value: string) => void;
}

function TimeFrame({ startDate, endDate, onEndDateChange, onStartDateChange }: Props) {
	const dateFromId = 'date-from-input-id';
	const dateEndId = 'date-end-input-id';

	return (
		<>
			<Form.Group>
				<Form.Label htmlFor={dateFromId}>
					<Translate id="user-outofoffice.StartDate" />
				</Form.Label>
				<DatePicker
					hasClearButton
					onChange={(date) => onStartDateChange(date ? date.toISOString() : '')}
					value={startDate ? new Date(startDate) : undefined}
					inputProps={{
						id: dateFromId,
					}}
					disabledDays={
						endDate
							? [{ after: new Date(endDate), before: new Date() }]
							: [{ before: new Date() }]
					}
				/>
			</Form.Group>
			<Form.Group>
				<Form.Label htmlFor={dateFromId}>
					<Translate id="user-outofoffice.EndDate" />
				</Form.Label>
				<DatePicker
					hasClearButton
					onChange={(date) => {
						const modifiedDate = date ? endOfDay(date) : undefined;
						modifiedDate?.setSeconds(0, 0);
						onEndDateChange(modifiedDate ? modifiedDate.toISOString() : '');
					}}
					value={endDate ? new Date(endDate) : undefined}
					inputProps={{
						id: dateEndId,
					}}
					disabledDays={
						startDate
							? [{ before: addDays(new Date(startDate), 1) }]
							: [{ before: new Date() }]
					}
				/>
			</Form.Group>
		</>
	);
}

export default TimeFrame;
